<template>
  <el-dialog
    title="服饰产品搜索"
    :visible.sync="dialogVisible"
    width="40%"
    top="5vh"
    :close-on-click-modal="false"
    custom-class="dress-search-dialog"
    @close="handleClose">
    <div class="search-dialog-content">
      <el-form :model='searchCondition' inline size='mini' @submit.native.prevent class="compact-search-form">
        <el-form-item label='产品名称'>
          <el-input
            placeholder='产品名称'
            v-model='searchCondition.title'
            clearable
            class="search-input"
          />
        </el-form-item>

        <el-form-item label='品牌'>
          <el-input
            placeholder='品牌'
            v-model='searchCondition.brand_name'
            clearable
            class="search-input"
          />
        </el-form-item>

        <el-form-item label='负责人'>
          <ProductLeaderSelect
            ref='refProductLeader'
            :leader-id.sync='searchCondition.leader_id'
            leader-type='product-dress'
            @selected="handleLeaderSelected"
            v-if="userPermissions.indexOf('product_view_all') > -1"
          />
          <span v-else class="current-user">{{ userInfo.nickname }}</span>
        </el-form-item>

        <el-form-item label='是否标品'>
          <el-select
            clearable
            placeholder="请选择是否标品"
            v-model="searchCondition.wares_standard_is"
            class="search-select"
          >
            <el-option v-for="item in standardOption" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label='价格区间'>
          <el-select v-model="modePrice" placeholder="">
            <el-option key="price" label="日常价" value="price"></el-option>
            <el-option key="lb_price" label="直播价" value="lb_price"></el-option>
          </el-select>
          <el-input placeholder='最低价' v-model='price[0]' clearable/>
          <span>~</span>
          <el-input placeholder='最高价' v-model='price[1]' clearable/>
        </el-form-item>

        <el-form-item label='季节性'>
          <el-select
            clearable
            v-model='searchCondition.used_season'
            placeholder='季节性'
            class="search-select"
          >
            <el-option label='春' value='春'></el-option>
            <el-option label='夏' value='夏'></el-option>
            <el-option label='秋' value='秋'></el-option>
            <el-option label='冬' value='冬'></el-option>
          </el-select>
        </el-form-item>

      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleCancel">取消</el-button>
      <el-button type="primary" @click="handleConfirm">搜索</el-button>
      <el-button @click="handleReset">重置</el-button>
    </div>
  </el-dialog>
</template>

<script>
import ProductLeaderSelect from '@/pages/lb/components/ProductLeaderSelect'
import {mapGetters} from "vuex";

export default {
  name: 'DressSearchForm',
  components: {
    ProductLeaderSelect
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    searchCondition: {
      type: Object,
      default: () => ({})
    },
    modePrice: {
      type: String,
      default: 'price'
    },
    price: {
      type: Array,
      default: () => []
    },
    standardOption: {
      type: Array,
      default: () => []
    },
  },
  computed: {
    ...mapGetters(['userPermissions', 'userInfo']),

    dialogVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    }
  },
  methods: {
    handleConfirm() {
      this.$emit('confirm')
      this.dialogVisible = false
    },

    handleCancel() {
      this.dialogVisible = false
      this.$emit('cancel')
    },

    handleReset() {
      // 重置负责人选择器
      if (this.$refs.refProductLeader) {
        this.$refs.refProductLeader.clear()
      }
      // 触发父组件的重置方法
      this.$emit('reset')
    },

    handleClose() {
      this.$emit('close')
    },

    handleLeaderSelected(option) {
      this.$emit('leader-selected', option)
    }
  },
  watch: {
    modePrice(val) {
      this.$emit('update:modePrice', val)
    },
    price(val) {
      this.$emit('update:price', val)
    }
  }
}
</script>

<style scoped>
/* 搜索弹窗样式优化 - 紧凑布局 */
.dress-search-dialog .el-dialog__body {
  max-height: 70vh;
  overflow-y: auto;
  padding: 16px 20px;
}

::v-deep .dress-search-dialog .el-form-item__label {
  text-align: left !important;
}

.dress-search-dialog .search-dialog-content {
  padding: 0;
}

.dress-search-dialog .search-dialog-content .compact-search-form {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 12px;
  align-items: start;
}

.dress-search-dialog .search-dialog-content .compact-search-form .el-form-item {
  margin-bottom: 0;
  display: flex;
  flex-direction: column;
  min-height: 56px;
}

.dress-search-dialog .search-dialog-content .compact-search-form .el-form-item .el-form-item__label {
  width: auto;
  text-align: left;
  font-weight: 500;
  color: #606266;
  margin-bottom: 4px;
  line-height: 1.2;
  padding-bottom: 0;
  font-size: 13px;
  justify-content: flex-start;
}

.dress-search-dialog .search-dialog-content .compact-search-form .el-form-item .el-form-item__content {
  flex: 1;
  display: flex;
  align-items: center;
}

.dress-search-dialog .search-dialog-content .compact-search-form .el-form-item .el-form-item__content .el-input,
.dress-search-dialog .search-dialog-content .compact-search-form .el-form-item .el-form-item__content .el-select {
  width: 100%;
}

/* 特殊处理价格范围表单项目 */
.dress-search-dialog .search-dialog-content .compact-search-form .el-form-item:has(.el-select + .el-input) {
  min-height: 56px;
}

.dress-search-dialog .search-dialog-content .compact-search-form .el-form-item:has(.el-select + .el-input) .el-form-item__content {
  display: flex;
  align-items: center;
  gap: 4px;
  width: 100%;
}

.dress-search-dialog .search-dialog-content .compact-search-form .el-form-item:has(.el-select + .el-input) .el-form-item__content .el-select {
  flex: 1;
  min-width: 0;
  width: 30%; /* 价格类型选择器占30% */
}

.dress-search-dialog .search-dialog-content .compact-search-form .el-form-item:has(.el-select + .el-input) .el-form-item__content .el-input {
  flex: 1;
  min-width: 0;
  width: 30%; /* 每个价格输入框占30% */
}

.dress-search-dialog .search-dialog-content .compact-search-form .el-form-item:has(.el-select + .el-input) .el-form-item__content span {
  color: #909399;
  font-size: 13px;
  flex-shrink: 0;
  white-space: nowrap;
  width: 10%; /* 分隔符占10% */
  text-align: center;
}

/* 当前用户显示样式 */
.current-user {
  color: #606266;
  font-size: 13px;
  font-weight: 500;
  padding: 8px 12px;
  background: #f5f7fa;
  border-radius: 4px;
  border: 1px solid #e4e7ed;
}

/* 响应式设计 */
@media (max-width: 1200px) {
  .dress-search-dialog .search-dialog-content .compact-search-form {
    grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
    gap: 10px;
  }
}

@media (max-width: 768px) {
  .dress-search-dialog {
    width: 95% !important;
    margin: 2vh auto !important;
  }

  .dress-search-dialog .search-dialog-content .compact-search-form {
    grid-template-columns: 1fr;
    gap: 10px;
  }

  .dress-search-dialog .search-dialog-content .compact-search-form .el-form-item {
    min-height: 52px;
  }
}

/* 弹窗底部按钮优化 */
.dress-search-dialog .dialog-footer {
  text-align: center;
  padding: 16px 20px;
  border-top: 1px solid #ebeef5;
  background: #f8f9fa;
}

.dress-search-dialog .dialog-footer .el-button {
  min-width: 90px;
  margin: 0 6px;
  border-radius: 3px;
  font-weight: 500;
  font-size: 13px;
  padding: 8px 16px;
}

.dress-search-dialog .dialog-footer .el-button:first-child {
  margin-left: 0;
}

.dress-search-dialog .dialog-footer .el-button:last-child {
  margin-right: 0;
}

/* 弹窗标题样式优化 */
.dress-search-dialog .el-dialog__header {
  padding: 16px 20px 8px;
  border-bottom: 1px solid #ebeef5;
}

.dress-search-dialog .el-dialog__title {
  font-size: 15px;
  font-weight: 600;
  color: #303133;
}

/* 滚动条样式优化 */
.dress-search-dialog .el-dialog__body::-webkit-scrollbar {
  width: 4px;
}

.dress-search-dialog .el-dialog__body::-webkit-scrollbar-track {
  background: #f5f5f5;
  border-radius: 2px;
}

.dress-search-dialog .el-dialog__body::-webkit-scrollbar-thumb {
  background: #c0c4cc;
  border-radius: 2px;
}

.dress-search-dialog .el-dialog__body::-webkit-scrollbar-thumb:hover {
  background: #909399;
}

/* 紧凑布局额外优化 */
.dress-search-dialog .el-dialog {
  border-radius: 6px;
}

.dress-search-dialog .el-dialog__headerbtn {
  top: 14px;
  right: 16px;
}

.dress-search-dialog .el-dialog__headerbtn .el-dialog__close {
  font-size: 16px;
}


</style>
